import PropTypes from 'prop-types';
import React from 'react';
import { attributesToProps } from 'html-react-parser';
import { ToolLoader } from '@quickenloans-tools/tool-loader';
import { availableCalculators, calculatorEnvs } from './Constants';

const toCalculator = () => 
{
    const activeEnv = process.env.GATSBY_ACTIVE_ENV || process.env.NODE_ENV || 'local';

    const Wrapper = ({ name = '', type = '', attribs = {} }) => 
    {
        if (type !== 'tag') return null;
        if (!name || name !== 'div') return null;
        if (!attribs?.id) return null;
        if (!availableCalculators[attribs.id]) return null;
        if (!calculatorEnvs[activeEnv]) return null;

        const props = attributesToProps(attribs);

        return <ToolLoader
            tool={availableCalculators[attribs?.id]}
            eventHandler={() => {}}
            options={{
                domain: calculatorEnvs[activeEnv].domain
            }}
            {...props}
        />
    };

    Wrapper.propTypes = {
        name: PropTypes.oneOf(['div']),
        type: PropTypes.oneOf(['tag']),
        attribs: PropTypes.shape({
            class: PropTypes.string,
            id: PropTypes.string
        }),
    };

    return Wrapper;
};

export default toCalculator;
